import React from 'react';
import { useGameSocket } from '../../providers/gameSocket.provider';

export interface TimerProps{
    startCount?: number;
    onZero?: ()=> any;
    delay?: number;
    stop?: boolean;
    millisecondsWhen?: number;
    mode?: 'receiver' | 'default'
    displayRef?: React.LegacyRef<HTMLParagraphElement>
}

const Timer: React.FC<TimerProps> = ({ 
    startCount, onZero, delay = 0, stop = false, millisecondsWhen = 10000,
    mode = 'default',
    displayRef
})=>{

    // Hooks
    const { gameSocket } = useGameSocket();

    const timeRef = React.createRef<HTMLParagraphElement>();
    let initCount = startCount || 40;
    const countRef = React.useRef(initCount * 1000);
    let interval: NodeJS.Timeout | null = null;

    // State
    const [zeroReached, setZeroreached] = React.useState<boolean>(false);

    // Instantiate innerText of p element
    if (timeRef.current) {
        timeRef.current.innerText = (countRef.current).toString()
    }

    // Offset calculator
    const calculateOffset = ()=>{
        if (countRef.current === 0) {
            return 0;
        }
        countRef.current -= 100;
        return countRef.current;
    }

    // Format the time display
    const formatTime = (milliseconds: number)=>{
        if (!millisecondsWhen) {
            let seconds = (milliseconds/1000).toFixed(1);
            //let centisecond = Math.floor(milliseconds/100) - 
            let secondsString = seconds.toString();
            return `${secondsString.length === 3 ? '0' : ''}${seconds}`
        }
        else{
            if (milliseconds <= millisecondsWhen) {
                let seconds = (milliseconds/1000).toFixed(1);
                //let centisecond = Math.floor(milliseconds/100) - 
                let secondsString = seconds.toString();
                return `${secondsString.length === 3 ? '0' : ''}${seconds}`
            }
            else{
                let seconds = (milliseconds/1000).toFixed(0);
                return seconds;
            }
        }
    }

    // Time updating function
    const update = ()=> {
        let tempCount = calculateOffset();
        if (timeRef && timeRef.current) {
            timeRef.current.innerText = formatTime(tempCount);
        }
        if (tempCount === 0) {
            onZero && onZero();
            interval && clearInterval(interval);
            return;
        }
    }
    

    React.useEffect(() => {
        if (mode === 'default') {
            interval = setInterval(update, 100 + delay);
            return ()=> { interval && clearInterval(interval); }
        }
    },[]);

    React.useEffect(()=>{
        if (stop && timeRef.current) {
            timeRef.current.innerText = '0';
            onZero && onZero();
        }
    },[stop])

    React.useEffect(()=>{
        if (mode === 'receiver') {
            gameSocket?.on("time-count", (milliseconds)=>{
                if (timeRef.current) {
                    if (milliseconds < 0) {
                        let seconds = 0.0;
                        let secondsString = seconds.toString();
                        timeRef.current.innerText = `${secondsString.length === 3 ? '0' : ''}${seconds}`
                    }
                    else if (milliseconds === 0) {
                        onZero && onZero();
                    }
                    else if (milliseconds <= millisecondsWhen) {
                        let seconds = (milliseconds/1000).toFixed(1);
                        //let centisecond = Math.floor(milliseconds/100) - 
                        let secondsString = seconds.toString();
                        timeRef.current.innerText = `${secondsString.length === 3 ? '0' : ''}${seconds}`
                    }
                    else{
                        let seconds = (milliseconds/1000).toFixed(0);
                        timeRef.current.innerText = seconds;
                    }
                }
            })
        }
    },[])
    
    return(
        <p ref={displayRef ? displayRef : timeRef}></p>
    )
}

export default React.memo(Timer);